app.namespace('scroll');

app.scroll = (function ($) {    
    function init() {
    	$(window).on('scroll', Foundation.utils.throttle(function(e){
			var $nav = $('#header');
			if ($(window).scrollTop() > 89) {
				if ($nav.attr('class') == 'big') {
					$nav.attr('class','small');
				}
			} else {
				if ($nav.attr('class') == 'small') {
					$nav.attr('class','big');
				}  
			}
			if($('#secondary-menu:visible').length){
				$('#secondary-trigger .menu-icon a').eq(0).trigger('click');	
			}
		}, 300, true));
		/*$(window).on('scroll orientationchange touchmove', Foundation.utils.debounce(function(e){
			var scroll_position = $(window).scrollTop();
			var snap_range = 256;	
			$('#slides > li:not(#slides > li.no-snap), .scroll-item').each(function(){	
				var slide_top = $(this).offset().top;				
				var snap_from = Math.round(slide_top - (snap_range/2), 2);
				var snap_to = Math.round(slide_top + (snap_range/2), 2);		
				if( scroll_position >= snap_from && scroll_position <= snap_to ) {    		
					var snap_offset = 0;
					var scroll_to = $(this).offset().top - snap_offset;			
					scroll_diff = scroll_position - scroll_to;
					if(scroll_diff != "-1")
					{
						$("html, body").animate({ scrollTop: scroll_to}, 300, 'linear');	
					}			
				}
			});
		},400));*/
		$(window).on('ready resize orientation change', Foundation.utils.throttle(function(e){
			var h = $(window).height(), slides = $('#slides > li');
			slides.each(function(){
				var $this = $(this);
				$this.not('.no-fill').css('min-height', h).find('.valign-middle, .inner, .text, .image, .scroll-item').css('height', h).css('min-height',h);
				
			});
			initScrollSection(h);
			jQuery(window).trigger('resize').trigger('scroll');
		},300));
    }

    return {
        init: init
    };
}(jQuery));